<template>
  <div data-spec-sku class="min-w-0 leading-none tracking-wider">
    <div v-if="item.products && item.products.length" class="bg-white mt-2 desk:mt-0">
      <h2 class="mb-0 block border-b border-gray-50 px-5 py-4 text-[13px] font-bold text-gray-800 desk:text-base">
        選擇面值
      </h2>
      <ul class="flex flex-col">
        <li
          v-for="product in item.products"
          :key="product.no"
          class="spec-sku-row relative flex w-full cursor-pointer items-center border-b border-gray-50 px-5 py-4 transition-colors desk:py-3"
          :class="[
            product.no === form.product
              ? 'bg-primary/5'
              : product.stockout
                ? 'bg-gray-50/50'
                : 'bg-white desk:hover:bg-gray-50',
          ]"
          @click="$emit('select', product)"
        >
          <input
            type="radio"
            :name="radioGroup"
            :value="product.no"
            :checked="product.no === form.product"
            :aria-label="`${product.name}，${product.stockout ? '售罄，通知補貨' : currency + ' ' + (product.discount || product.price)}`"
            class="sr-only"
            @click.stop
            @change="$emit('select', product)"
          />
          <div class="flex-grow pr-4">
            <div
              class="break-words text-[14px] leading-snug"
              :class="
                product.no === form.product
                  ? 'font-bold text-primary'
                  : 'font-medium text-gray-800'
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div class="flex shrink-0 flex-col items-end">
            <div class="flex items-baseline text-primary">
              <span v-if="!product.stockout" class="text-[11px] font-bold">{{ currency }}</span>
              <span
                v-if="product.stockout"
                class="ml-0.5 text-[16px] font-bold tracking-tight"
              >售罄</span>
              <span
                v-else
                class="ml-[2px] text-[18px] font-bold tracking-tight"
              >{{ product.discount || product.price | number_format }}</span>
            </div>
            <del
              v-if="!product.stockout && product.discount && product.discount != product.price"
              class="mt-0.5 text-[11px] font-normal text-gray-500"
            >{{ product.price | number_format }}</del>
            <button
              v-if="product.stockout"
              type="button"
              class="mt-1 text-[12px] font-bold text-primary"
              @click.stop="$emit('select', product)"
            >
              通知補貨
            </button>
          </div>
          <div
            class="ml-4 flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full border-2 transition-all"
            :class="
              product.no === form.product
                ? 'scale-110 border-primary bg-primary text-white'
                : 'border-gray-200 bg-white'
            "
          >
            <svg
              v-if="product.no === form.product"
              xmlns="http://www.w3.org/2000/svg"
              class="h-[12px] w-[12px]"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </li>
      </ul>
    </div>
    <p v-else class="px-5 py-8 text-center text-sm text-gray-400">暫無面值</p>
    <div
      v-if="selectedProduct && !stockout && selectedProduct.fields && selectedProduct.fields.length"
      class="mt-2 border-b border-gray-100 bg-white px-5 py-5"
      data-view="options"
    >
      <h2 class="mb-4 block text-[13px] font-bold text-gray-800 desk:text-base">填寫資料</h2>
      <slot name="options" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    radioGroup() {
      const id = (this.item && (this.item.no || this.item.id)) || 'sku';
      return `specification-${id}-${this._uid}`;
    },
  },
  props: {
    item: { type: Object, required: true },
    form: { type: Object, required: true },
    selectedProduct: { type: Object, default: null },
    stockout: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
@media (min-width: 1024px) {
  .spec-sku-row:focus-within {
    outline: 2px solid var(--color-primary);
    outline-offset: -2px;
  }
}
</style>
